import { TypedMatNode } from "../_Base";
import { BaseTextureMapController, BooleanParamOptions, NodePathOptions } from "./_BaseTextureController";
import { NodeParamsConfig, ParamConfig } from "../../utils/params/ParamsConfig";
export function DisplacementMapParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.useDisplacementMap = ParamConfig.BOOLEAN(0, {
        separatorBefore: true,
        ...BooleanParamOptions(TextureDisplacementMapController)
      });
      this.displacementMap = ParamConfig.NODE_PATH("", NodePathOptions(TextureDisplacementMapController, "useDisplacementMap"));
      this.displacementScale = ParamConfig.FLOAT(1, {
        range: [0, 1],
        rangeLocked: [false, false],
        ...NodePathOptions(TextureDisplacementMapController, "useDisplacementMap")
      });
      this.displacementBias = ParamConfig.FLOAT(0, {
        range: [0, 1],
        rangeLocked: [false, false],
        ...NodePathOptions(TextureDisplacementMapController, "useDisplacementMap")
      });
    }
  };
}
class TextureDisplacementMapParamsConfig extends DisplacementMapParamConfig(NodeParamsConfig) {
}
class TextureDisplacementMapMatNode extends TypedMatNode {
}
export class TextureDisplacementMapController extends BaseTextureMapController {
  constructor(node) {
    super(node);
    this.node = node;
  }
  initializeNode() {
    this.add_hooks(this.node.p.useDisplacementMap, this.node.p.displacementMap);
  }
  async update() {
    this._update(this.node.material, "displacementMap", this.node.p.useDisplacementMap, this.node.p.displacementMap);
    const mat = this.node.material;
    mat.displacementScale = this.node.pv.displacementScale;
    mat.displacementBias = this.node.pv.displacementBias;
  }
  static async update(node) {
    node.controllers.displacementMap.update();
  }
}
